<div class="file-tab-container">
	<div class="header">
		<filter-chip
			[title]="'filetype'"
			[filterOptions]="filterVariablesList()"
			(filterSelected)="filter.set($event)"
		/>

		<button mat-icon-button class="primary-icon-button" (click)="fileInput.click()">
			<mat-icon svgIcon="add" />
			<input
				#fileInput
				type="file"
				[accept]="fileTypesConfig"
				[multiple]="true"
				(click)="$event.target['value'] = null"
				(change)="fileChanged($event)"
				hidden
			/>
		</button>
	</div>
	<div class="entity-list">
		<div class="entity-list-header">
			<h3>{{ 'attached_files' | translate }}</h3>

			<button mat-icon-button [matMenuTriggerFor]="actionsMenu">
				<mat-icon svgIcon="more_vert" />
			</button>
		</div>
		@for (file of filteredFiles(); track file.pk) {
			<mat-card class="attached-entity-card">
				<mat-card-content class="card-content">
					<mat-checkbox
						class="content-checkbox"
						[checked]="fileSelections.isSelected(file)"
						(change)="fileSelections.toggle(file)"
					/>
					<div class="content-info">
						<mat-card-title class="card-title">
							{{ file.name }}
						</mat-card-title>

						<mat-card-subtitle class="card-subtitle">
							@if (file.classificationsV2?.length > 0) {
								{{ file.classificationsV2[0].name }}
							} @else {
								{{ 'no_classification' | translate }}
							}
							<div class="dot"></div>
							{{ file.created | date: 'dd.MM.yyyy' }}
						</mat-card-subtitle>
					</div>
				</mat-card-content>
				<div class="card-img">
					@if (file.file?.contentType === 'image/jpeg') {
						<img [src]="file.file.url" alt="File Image" class="file-image" />
					} @else {
						<div class="document-type">
							<mat-icon
								class="document-icon"
								[ngClass]="getFileType(file.type).icon"
								[svgIcon]="getFileType(file.type).icon"
							/>
							{{ getFileType(file.type).name | translate }}
						</div>
					}
				</div>
			</mat-card>
		}
	</div>
</div>

<mat-menu #actionsMenu="matMenu">
	<button
		mat-menu-item
		[disabled]="!fileSelections.selected.length"
		(click)="unlinkFiles()"
	>
		<mat-icon svgIcon="remove-attachment" />
		{{ 'unlink_file' | translate: { value: fileSelections.selected?.length.toString() } }}
	</button></mat-menu
>
